module.exports = __webpack_public_path__ + "img/proje-1.c76048ed.jpg";